// Customer / lead contact card at the top of the activity composer.
import { Building2, Crown, Mail, MapPin, Phone, PhoneCall, PanelRightOpen, PanelRightClose, UserRound } from "lucide-react";

const gbp = (v) => (v ? `£${Number(v).toLocaleString("en-GB", { maximumFractionDigits: 0 })}` : "£0");

export default function CustomerBrief({ b, show360, onToggle360 }) {
  if (!b) return <div className="h-[92px] rounded-xl bg-white/[0.03] animate-pulse" />;
  const tel = (b.phone || "").replace(/[^\d+]/g, "");
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3.5" data-testid="activity-brief">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 shrink-0 rounded-full grid place-items-center bg-purple-500/20 text-purple-200"><UserRound className="w-5 h-5" /></div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-[15px] font-semibold text-white truncate" data-testid="activity-brief-name">{b.name}</span>
            <span data-testid="activity-brief-kind" className={`px-1.5 py-0.5 rounded text-[10px] font-mono uppercase ${b.is_lead ? "bg-amber-500/15 text-amber-200" : "bg-emerald-500/15 text-emerald-200"}`}>{b.is_lead ? "Lead" : "Customer"}</span>
            {b.tier && <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-mono bg-white/5 text-slate-200"><Crown className="w-3 h-3" />{b.tier}</span>}
          </div>
          <div className="mt-0.5 text-[11.5px] text-slate-400 flex flex-wrap gap-x-3">
            {b.company && <span className="inline-flex items-center gap-1"><Building2 className="w-3 h-3" />{b.company}</span>}
            <span>AM: <b className="text-slate-200">{b.am || "none"}</b></span>
            {!b.is_lead && <span>{gbp(b.ltv)} LTV · {b.orders || 0} orders</span>}
          </div>
        </div>
        <button type="button" onClick={onToggle360} data-testid="activity-brief-360"
          className="hidden md:inline-flex shrink-0 items-center gap-1.5 h-8 px-2.5 rounded-lg border border-white/10 text-[11.5px] text-slate-200 hover:bg-white/5">
          {show360 ? <PanelRightClose className="w-3.5 h-3.5" /> : <PanelRightOpen className="w-3.5 h-3.5" />} {show360 ? "Hide 360" : "Show 360"}
        </button>
      </div>
      <div className="mt-3 grid sm:grid-cols-3 gap-2 text-[12px]">
        <div className="flex items-center gap-1.5 min-w-0" data-testid="activity-brief-phone">
          <Phone className="w-3.5 h-3.5 text-slate-500 shrink-0" />
          {b.phone ? <a href={`tel:${tel}`} className="text-slate-200 hover:underline truncate">{b.phone}</a> : <span className="text-slate-500">No phone</span>}
          <button type="button" disabled title="Call with JustCall (coming soon)" data-testid="activity-justcall"
            className="ml-auto shrink-0 inline-flex items-center gap-1 h-6 px-2 rounded-md border border-white/10 text-[10.5px] text-slate-500 cursor-not-allowed">
            <PhoneCall className="w-3 h-3" /> JustCall</button>
        </div>
        <div className="flex items-center gap-1.5 min-w-0"><Mail className="w-3.5 h-3.5 text-slate-500 shrink-0" />
          {b.email ? <a href={`mailto:${b.email}`} className="text-slate-200 hover:underline truncate">{b.email}</a> : <span className="text-slate-500">No email</span>}</div>
        <div className="flex items-center gap-1.5 min-w-0"><MapPin className="w-3.5 h-3.5 text-slate-500 shrink-0" />
          <span className={`truncate ${b.address ? "text-slate-200" : "text-slate-500"}`} title={b.address || ""}>{b.address || "No address"}</span></div>
      </div>
    </div>
  );
}
